import React, { useCallback, useState } from 'react';
import { Modal } from '../components';

interface UseModalProps {
    /**
     * When modal is shown
     */
    onShow?: () => void;
    /**
     * When modal is hidden
     */
    onHide?: () => void;
}
export function useModal({ onShow, onHide }: UseModalProps = {}) {
    const [isVisible, setIsVisible] = useState(false);

    const showModal = useCallback(() => {
        setIsVisible(true);
        // prevent body scroll
        document.body.style.overflow = 'hidden';
        return onShow && onShow();
    }, [setIsVisible, onShow]);

    const hideModal = useCallback(() => {
        setIsVisible(false);
        // enable back the body scroll, caveat: will not work with `modal in a modal` case
        document.body.style.overflow = 'auto';
        return onHide && onHide();
    }, [setIsVisible, onHide]);

    const modal = useCallback(
        ({
            children,
            hasCustomHeader,
            hasAutoHide,
            hasCloseButton,
            title,
            variant,
            className,
            overlayClassName,
            icon,
            iconColor,
            iconSize
        }) => (
            <>
                {isVisible && (
                    <Modal
                        hasCustomHeader={hasCustomHeader}
                        hasAutoHide={hasAutoHide}
                        hasCloseButton={hasCloseButton}
                        title={title}
                        onHide={hideModal}
                        variant={variant}
                        className={className}
                        overlayClassName={overlayClassName}
                        icon={icon}
                        iconColor={iconColor}
                        iconSize={iconSize}
                    >
                        {children}
                    </Modal>
                )}
            </>
        ),
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
        [isVisible]
    );

    return {
        showModal,
        hideModal,
        modal,
        isVisible
    };
}
